import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders, faTimes } from '@fortawesome/free-solid-svg-icons';

const FilterIcon = ({ onClick, isOpen }) => {
  const icon = isOpen ? faTimes : faSliders;
  return (
    <FontAwesomeIcon
      icon={icon}
      size="lg"
      className="text-gray-500 cursor-pointer"
      onClick={onClick}
    />
  );
};

export default FilterIcon;
